import { useEffect, useState } from "react";
import Navbar from "../../shared/Navbar";
import Footer from "../../shared/Footer";

const AboutUs = () => {
  return (
    <>
      <div className="banner_outer">
        <Navbar />
      </div>

      <section className="aboutus-section overflow-hidden" style={{ padding: "60px 0px 0px 0px" }}>
        <div className="container">
          <div className="aboutus_content d-flex justify-content-center">
            <h2 className="mb-0">About Us</h2>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="aboutus_text" data-aos="fade-left">
                <p className="mb-4">
                  <strong>Cosmic Advice</strong> is your gateway to customized planetary consultation, offering spiritual and metaphysical guidance and advice to users based on their cosmic conditions. The platform provides live, on-demand real-time consultation, personalized advice and readings with professional astrologers, which breaks the traditional models and barriers. The platform provides interpretations of planetary positions and number patterns, offering insights into individual future events. Cosmic advice can be a source of comfort and strength during challenging periods, offering a perspective that goes beyond personal limitations. It can be used to gain insights into the best course of action in a particular situation, drawing on the wisdom of the universe.
                </p>
                <h4 className="mb-4">Here are some key features of Cosmic Advice that make it a must-have astrology app:</h4>
                <h5>Live, On-Demand Readings</h5>
                <p className="mb-4">Instantly connect with professional astrologers, tarot readers, and Vastu experts for real-time one-to-one spiritual guidance tailored to your cosmic influences.</p>
                <h5>Personalized Birth Chart Analysis</h5>
                <p className="mb-4">Gain deep insights into your personality, strengths, and life path through an accurate interpretation of your birth date and celestial alignments.</p>
                <h5>Daily Horoscopes & Predictions</h5>
                <p className="mb-4">Stay ahead of life's events with daily, weekly, and monthly horoscopes based on your zodiac sign and planetary movements.</p>
                <h5>Compatibility Readings</h5>
                <p className="mb-4">Explore relationship dynamics with love, friendship, and career compatibility analyses to help you build deeper connections.</p>
                <h5>Global Access to Experts</h5>
                <p className="mb-4">Consult astrologers from anywhere in the world, specializing in Southeast Asian astrology, Vastu Shastra, and Western astrology.</p>
                <h5>Customized Planetary Consultation</h5>
                <p className="mb-4">Receive personalized advice based on your unique astrological conditions, helping you navigate key life decisions with cosmic wisdom.</p>
                <h5>Fast and Safe Payments</h5>
                <p className="mb-4">Leverage multiple payment gateways to enable secure and hassle-free online payments. The app allows astrologers to set consultation fees and track their daily transactions.</p>
                <h5>Push Notifications, SMS, and Email</h5>
                <p className="mb-4">Trigger push notifications, emails, and SMS to remind clients about their potential appointments. This will ensure your calendars never run out of clients.   The universe speaks in whispers— <strong>are you ready to listen?</strong> Whether you're searching for clarity, guidance, or reassurance, <strong>Cosmic Advice</strong> connects you with expert astrologers who translate celestial wisdom into meaningful insights. Unlock your destiny, embrace self-awareness, and navigate life’s journey with confidence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
      <Footer />
    </>
  );
};

export default AboutUs;
